import classnames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { Node_Type } from "./../../ricos-types";
import { getLangDir } from "./../../wix-rich-content-common";
import Card from "../components/Card";
import { ROOT } from "../dataHooks";
import styles from "../statics/styles/widget-scss";
import { VERTICAL_EMBED_TYPE } from "../types";
import { verticalsDataBuilder } from "./verticalsDataBuilder";
const VerticalEmbedViewer = ({
  settings,
  componentData,
  helpers,
  nodeId
}) => {
  const { t, locale } = useContext(RicosContext);
  const onClick = () => helpers.onViewerAction?.(VERTICAL_EMBED_TYPE, "Click", componentData.type, nodeId, {
    type: Node_Type.APP_EMBED,
    appEmbedData: componentData
  });
  const props = verticalsDataBuilder(componentData, t, settings.changeBaseUrl);
  const direction = getLangDir(locale);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames(styles.card, { [styles.slimLayout]: settings.slimLayout }),
        "data-hook": ROOT,
        onClick
      },
      /* @__PURE__ */ React.createElement(Card, { ...props, t, direction, disabled: settings.disabled })
    )
  );
};
export {
  VerticalEmbedViewer
};
//# sourceMappingURL=vertical-embed-viewer.js.map
